import React from "react";
import { Table } from "react-bootstrap";
import {
  selectFilterResult,
  selectSearchResult,
} from "../../../features/search/slice";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { toNumber } from "lodash";
function SearchTable({ data }) {
  const navigate = useNavigate();

  const tableData = data ?? [];

  const handleRowClick = (studentId) => {
    navigate(`/member/${studentId}`);
  };
  return (
    <div className="table-responsive">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Full Name</th>
            <th>Student ID</th>
            <th>Email</th>
            <th>Vivo</th>
            <th>Committee</th>
            <th>Attendance</th>
            <th>Socials</th>
            <th>Workshops</th>
            <th>Negative</th>
            <th>Payment</th>
            <th>Fundraiser</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((member) => {
            const key = member.id;
            return (
              <tr
                key={"SearchMemberTableRow-" + key}
                onClick={() => handleRowClick(member?.studentId)}
              >
                <td>{member?.fullName ?? ""}</td>
                <td>{member?.studentId ?? ""}</td>
                <td>{member?.email ?? ""}</td>
                <td>{toNumber(member?.vivo) ?? ""}</td>
                <td>{toNumber(member?.committeeCredit) ?? ""}</td>
                <td>{toNumber(member?.meetingAttendance) ?? ""}</td>
                <td>{toNumber(member?.socials) ?? ""}</td>
                <td>{member?.workshops ?? ""}</td>
                <td>{member?.negative ?? ""}</td>
                <td>
                  {member?.payment === true ? "received" : "not received"}
                </td>
                <td>{member?.chapterInvolvement ?? ""}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}

export default SearchTable;

export const SearchByIdTable = connect((state) => {
  return {
    data: selectSearchResult(state),
  };
})(SearchTable);

export const FilterMemberTable = connect((state) => {
  const stateData = selectFilterResult(state);
  return {
    data: stateData,
  };
})(SearchTable);
